// @flow
import styled from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

// Envoltorio gris de las páginas de listado de asesores: empresas, profesionales y provincia.
export const MainGrey = styled.main`
  display: flex;
  flex: 1;
  flex-direction: column;
  ${({ minHeight }) => (minHeight ? 'height: 100vh' : null)};
  padding-bottom: 30px;
  background-color: ${({ theme }) => theme.colors.uiLL};

  /* stylelint-disable */
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    display: block;
    flex: auto;
  }
  /* stylelint-enable */
`;

// Cuántas tarjetas de un listado cargan su imagen de inmediato: las primeras suelen
// caer dentro del viewport inicial y diferirlas retrasaría el LCP. El resto va en lazy.
export const EAGER_LIST_ICONS = 3;

// Cabecera del listado: el H1 y, en las escenas que los tienen, los filtros al lado.
export const ListHeader = styled(Flex)`
  padding-top: 60px;
  padding-bottom: 12px;

  h1 {
    /* stylelint-disable */
    padding-bottom: 12px !important;
    /* stylelint-enable */
    padding-right: 24px;
    line-height: 50px;

    ${maxMediaQueries.phablet`
      line-height: 39px;
    `};
  }
`;

// Variante que apila título y filtros en móvil (la usa el listado de empresas,
// que es el único con filtros junto al H1).
export const ListHeaderStacked = styled(ListHeader)`
  ${maxMediaQueries.phablet`
    display: block;
  `};
`;
